export default {"src":"/_next/static/media/cxr6.4455f4b7.svg","height":22,"width":19,"blurWidth":0,"blurHeight":0};